export enum TryActivateResult {
  Success = 0,
  NotLoggedIn = 1,
  NoAccess = 2
}
